import { fetchUserData } from "./authService";
import { getAccessToken } from "context/OAuth/authService";

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

const getUserData = async () => {
  const token = getAccessToken();

  if (!token) {
    console.error("No access token found");
    return null;
  }
  console.log("token : ", token);

  try {
    const response = await fetchUserData();

    const userData = response?.data;
    return userData;
  } catch (error) {
    console.log("Error fetching user data:", error);
    return null;
  }
};

export default getUserData;
